import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { TagProjectCTA, TagProjectModalRenderer } from 'dibs-project-forms';
import classnames from 'classnames';

import styles from './styles/TagProject.scss';

export function TagProject({
    projects,
    selecting,
    isPublic,
    itemId,
    userId,
    relayEnvironment,
    source,
    onSuccess,
    isListView,
}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const hasProjects = Array.isArray(projects) && projects.length > 0;

    function handleSuccess(tagAdded) {
        setIsModalOpen(false);
        onSuccess(tagAdded);
    }

    function handleClick(e) {
        e.preventDefault();
        setIsModalOpen(true);
    }

    const projectClasses = classnames(styles.project, { [styles.isGridView]: !isListView });

    let cta = (
        <div className={projectClasses}>
            <div
                className={classnames(styles.add, { [styles.disabled]: selecting })}
                data-tn="add-project-tag"
                onClick={handleClick}
            >
                <FormattedMessage
                    id="portfolio.tagProject.addProjectTag"
                    defaultMessage="Add project tag"
                />
            </div>
        </div>
    );

    if (hasProjects) {
        cta = (
            <TagProjectCTA
                className={projectClasses}
                canAddProject={!isPublic}
                disabled={selecting}
                projects={projects}
                onClick={handleClick}
                displayInSingleRow={!isListView}
            />
        );
    }

    return (
        <React.Fragment>
            {cta}
            <TagProjectModalRenderer
                environment={relayEnvironment}
                isOpen={isModalOpen}
                itemId={itemId}
                onClose={() => setIsModalOpen(false)}
                onDone={handleSuccess}
                source={source}
                userId={userId}
            />
        </React.Fragment>
    );
}

TagProject.propTypes = {
    projects: PropTypes.array,
    selecting: PropTypes.bool,
    isPublic: PropTypes.bool,
    itemId: PropTypes.string,
    userId: PropTypes.string,
    relayEnvironment: PropTypes.object,
    source: PropTypes.string,
    onSuccess: PropTypes.func,
    isListView: PropTypes.bool,
};
